import { format } from 'date-fns';
import { DEFAULT_DATE_FORMAT } from '@components/DateInput/DateInput';

export const formatDate = (date: Date | null) => {
  if (date !== null && date.getTime()) return format(date, DEFAULT_DATE_FORMAT);
  return null;
};
